'use strict';
/**
 * A set of directives for left and right sidebar.
 */
Sidebar.$inject = ['$document', '$rootScope', 'Club', 'Court', 'Backoffice'];


export async function Sidebar($document, $rootScope, Club, Court, Backoffice) {

    return {
        replace: false,
        restrict: 'C',
        link: function (scope, elem, attrs) {
            var shouldCloseOnOuterClicks = true;

            if (attrs.closeOnOuterClicks === 'false' || attrs.closeOnOuterClicks === '0') {
                shouldCloseOnOuterClicks = false;
            }

            var isAncestorOrSelf = function (element, target) {
                var parent = element;

                while (parent.length > 0) {
                    if (parent[0] === target[0]) {
                        parent = null;
                        return true;
                    }
                    parent = parent.parent();
                }

                parent = null;
                return false;
            };

            var closeOnOuterClicks = function (e) {
                if (!isAncestorOrSelf(angular.element(e.target), elem)) {
                    $('#app .app-content').one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {

                        if (!$('#app').hasClass('app-slide-off') && !$('#app').hasClass('app-offsidebar-open')) {
                            var $winScrollTop = Math.abs($('#app .main-content').position().top);

                            $('#app .main-content').css({
                                position: 'relative',
                                top: 'auto'
                            });

                            window.scrollTo(0, $winScrollTop);
                            $('footer').show();
                            $('#app .app-content').off('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
                        }
                    });
                    $rootScope.toggle(attrs.id, 'off');
                    e.preventDefault();
                    return false;
                }
            };

            var clearCb1 = angular.noop();

            if (shouldCloseOnOuterClicks) {
                clearCb1 = $rootScope.$on('ATC.toggled', function (e, id, active) {
                    if (id === attrs.id) {
                        if (active) {
                            setTimeout(function () {
                                $document.on('click tap', closeOnOuterClicks);
                            }, 300);
                        } else {
                            $document.off('click tap', closeOnOuterClicks);
                        }
                    }
                });
            }

            scope.$on('$destroy', function () {
                clearCb1();
                $document.off('click tap', closeOnOuterClicks);
            });

        }
    };
}


export function SearchForm() {
    return {
        restrict: 'AC',
        link: function (scope, elem, attrs) {
            var wrap = $('.app-aside');
            var searchForm = elem.children('form');
            var formWrap = elem.parent();

            $('.s-open').on('click', function (e) {
                searchForm.prependTo(wrap);
                e.preventDefault();
                $(document).on('mousedown touchstart', closeForm);
            });
            $('.s-remove').on('click', function (e) {
                searchForm.appendTo(elem);
                e.preventDefault();
            });
            var closeForm = function (e) {
                if (!searchForm.is(e.target) && searchForm.has(e.target).length === 0) {
                    $('.s-remove').trigger('click');
                    $(document).off('mousedown touchstart', closeForm);
                }
            };
        }
    };

    function isSidebarClosed() {
        return $('.app-sidebar-closed').length;
    }

    function isSidebarFixed() {
        return $('.app-sidebar-fixed').length;
    }

}


AppSide.$inject = ['$window', '$rootScope', '$timeout', 'APP_MEDIAQUERY'];

export function AppSide($window, $rootScope, $timeout, mq) {
    var $html = $('html'), $win = $($window), _this, wrap = $('.app-aside');

    $("#app").addClass("bg-white");
    
    return {
        restrict: 'AC',

        link: function (scope, elem, attrs, controllers) {
            var eventObject = isTouch() ? 'click' : 'mouseenter';
            var ul = '';
            var menuTitle;
            var wrap = $('.app-aside');
            elem.on('click', 'a', function (e) {

                _this = $(this);
                if (isSidebarClosed() && !isMobile() && !_this.closest('ul').hasClass('sub-menu')) {
                    return;
                }

                _this.closest('ul').find('.open').not('.active').children('ul').not(_this.next()).slideUp(200).parent('.open').removeClass('open');
                if (_this.next().is('ul') && _this.parent().toggleClass('open')) {

                    _this.next().slideToggle(200, function () {
                        $win.trigger('resize');

                    });
                    e.stopPropagation();
                    e.preventDefault();
                } else {
                    $rootScope.toggle('sidebar', 'off');

                }
            });
            elem.on(eventObject, 'a', function (e) {

                if (!isSidebarClosed() || isMobile()) {
                    return;
                }
                _this = $(this);

                if (!_this.parent().hasClass('hover') && !_this.closest('ul').hasClass('sub-menu')) {

                    wrapLeave();
                    _this.parent().addClass('hover');
                    menuTitle = _this.find('.item-inner').clone();
                    if (_this.parent().hasClass('active')) {

                        menuTitle.addClass('active');
                    }
                    var itemRect = _this.parent()[0].getBoundingClientRect();
                    var sidebarRect = $('#sidebar')[0].getBoundingClientRect();
                    var navMarginTop = parseFloat($('#sidebar .main-navigation-menu').css('margin-top')) || 0;
                    var itemTop = (isSidebarFixed() ? itemRect.top : (itemRect.top - sidebarRect.top)) - navMarginTop;
                    var itemHeight = itemRect.height || _this.outerHeight();
                    menuTitle.css({
                        position: isSidebarFixed() ? 'fixed' : 'absolute',
                        height: itemHeight,
                        top: itemTop,
                        zIndex: 1052
                    }).appendTo(wrap);
                    if (_this.next().is('ul')) {
                        ul = _this.next().clone(true);

                        ul.appendTo(wrap).css({
                            top: itemTop + itemHeight,
                            position: isSidebarFixed() ? 'fixed' : 'absolute',
                            zIndex: 1052
                        });
                        if (isSidebarFixed()) {
                            ul.css('max-height', Math.max(120, $win.height() - itemTop - itemHeight - 8));
                        }

                        wrap.children().first().scroll(function () {
                            if (isSidebarFixed()) {
                                wrapLeave();
                            }
                        });

                        setTimeout(function () {

                            if (!wrap.is(':empty')) {
                                $(document).on('click tap', wrapLeave);
                            }
                        }, 300);

                    } else {
                        ul = '';
                        return;
                    }

                }
            });
            wrap.on('mouseleave', function (e) {

                $(document).off('click tap', wrapLeave);
                $('.hover', wrap).removeClass('hover');
                $('> .item-inner', wrap).remove();
                $('> ul', wrap).remove();

            });

            function wrapLeave() {
                wrap.trigger('mouseleave');
            }


            $rootScope.$on('$locationChangeSuccess', function () {
                var newPath;
                newPath = window.location.hash;
                angular.forEach(elem.find('.main-navigation-menu a'), function (domLink) {
                    var link = angular.element(domLink);
                    var menu;
                    if (domLink.hash === newPath && (!isSidebarClosed() || isMobile())) {

                        if (link.closest('ul').hasClass('sub-menu')) {
                            menu = link.closest('ul');
                            var activeMenu = menu;
                            menu.slideDown(200).parent().siblings().children('.sub-menu').slideUp(200, function () {
                                $(this).parent().removeClass('open');
                            });
                        } else {
                            $('.sub-menu').slideUp(200, function () {
                                $(this).parent().removeClass('open');
                            });
                        }

                    }
                    activeMenu = null;
                    menu = null;
                });
            });

        }
    };

    function isTouch() {
        return $html.hasClass('touch');
    }

    function isMobile() {
        return $win.width() < mq.desktop;
    }

    function isSidebarClosed() {
        return $('.app-sidebar-closed').length;
    }

    function isSidebarFixed() {
        return $('.app-sidebar-fixed').length;
    }

}

SidebarMobileToggler.$inject = ['$window', '$rootScope', '$timeout', 'APP_MEDIAQUERY'];

export function SidebarMobileToggler($window, $rootScope, $timeout, mq) {
    var $html = $('html'), $win = $($window), _this, $winOffsetTop = 0, $winScrollTop = 0, $appWidth;
    return {
        restrict: 'C',

        link: function (scope, elem, attrs, controllers) {
            elem.on('click', function () {

                if (!$('#app').hasClass('app-slide-off') && !$('#app').hasClass('app-offsidebar-open')) {
                    $winOffsetTop = $win.scrollTop();
                    $winScrollTop = 0;
                    $('footer').hide();
                    $appWidth = $('#app .main-content').innerWidth();
                    $('#app .main-content').css({
                        position: 'absolute',
                        top: -$winOffsetTop,
                        width: $appWidth
                    });
                } else {
                    $winScrollTop = $winOffsetTop;
                }
                $('#app .app-content').one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {

                    if (!$('#app').hasClass('app-slide-off') && !$('#app').hasClass('app-offsidebar-open')) {
                        $('#app .main-content').css({
                            position: 'relative',
                            top: 'auto',
                            width: 'auto'
                        });

                        window.scrollTo(0, $winScrollTop);
                        $('footer').show();
                        $('#app .app-content').off('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
                    }

                });
            });

        }
    };
}
